export const PERSONAL_INTERACTIVE_ANIMATED_WIDGET_EXPERIMENT_ID = '33125818722'

const vtConfig = [
  {
    id: '21318169096',
    name: 'PL Widgets Rate Table Link CTA to Landing Page',
    isManualTriggering: false,
    isRunning: true,
    isMobile: true,
    isDesktop: true,
    isTablet: true,
    allowOrganicTraffic: true,
    allowNonOrganicTraffic: true,
    urlConditions: [
      {
        url: 'personal-loan/rate-table.*theme=fox.*?',
        type: 'regexp',
      },
    ],
    variations: [
      {
        id: 0,
        description: 'V0 PL Widget CTA PL PQ form',
        isPaused: false,
        weight: 0.5,
      },
      {
        id: 1,
        description: 'V1 PL Widget CTA PL Landing Page',
        isPaused: false,
        weight: 0.5,
      },
    ],
    gaCustomDimension: 100,
  },
  {
    id: '50600573151',
    name: 'IS Widgets Rate Table Link CTA to Landing Page',
    isManualTriggering: false,
    isRunning: true,
    isMobile: true,
    isDesktop: true,
    isTablet: true,
    allowOrganicTraffic: true,
    allowNonOrganicTraffic: true,
    urlConditions: [
      {
        url: 'student-loan/rate-table.*theme=fox.*?',
        type: 'regexp',
      },
    ],
    variations: [
      {
        id: 0,
        description: 'V0 IS Widget CTA IS PQ form',
        isPaused: false,
        weight: 0.5,
      },
      {
        id: 1,
        description: 'V1 IS Widget CTA IS Landing Page',
        isPaused: false,
        weight: 0.5,
      },
    ],
    gaCustomDimension: 100,
  },
  {
    id: '62336686311',
    name: 'SLR Widgets Rate Table Link CTA to Landing Page',
    isManualTriggering: false,
    isRunning: true,
    isMobile: true,
    isDesktop: true,
    isTablet: true,
    allowOrganicTraffic: true,
    allowNonOrganicTraffic: true,
    urlConditions: [
      {
        url: 'student-loan-refi/rate-table.*theme=fox.*?',
        type: 'regexp',
      },
    ],
    variations: [
      {
        id: 0,
        description: 'V0 SLR Widget CTA SLR form',
        isPaused: false,
        weight: 0.5,
      },
      {
        id: 1,
        description: 'V1 SLR Widget CTA SLR Landing Page',
        isPaused: false,
        weight: 0.5,
      },
    ],
    gaCustomDimension: 100,
  },
  {
    id: PERSONAL_INTERACTIVE_ANIMATED_WIDGET_EXPERIMENT_ID,
    name: 'PL Animated vs Interactive Widget',
    isManualTriggering: false,
    isRunning: true,
    isMobile: true,
    isDesktop: true,
    isTablet: true,
    allowOrganicTraffic: true,
    allowNonOrganicTraffic: true,
    urlConditions: [
      {
        url: 'personal-loan/rich-cta(.*variation=interactive.*theme=fox.*?)|(.*theme=fox.*variation=interactive.*?)',
        type: 'regexp',
      },
    ],
    variations: [
      {
        id: 0,
        description: 'V0 Baseline PL Interactive Widget',
        isPaused: false,
        weight: 0.5,
      },
      {
        id: 1,
        description: 'V1 PL Animated Widget',
        isPaused: false,
        weight: 0.5,
      },
    ],
    gaCustomDimension: 100,
  },
]

export default vtConfig
